import { render, staticRenderFns } from "./PopupCaptchar.vue?vue&type=template&id=6bcd5e07"
import script from "./PopupCaptchar.vue?vue&type=script&lang=js"
export * from "./PopupCaptchar.vue?vue&type=script&lang=js"
import style0 from "./PopupCaptchar.vue?vue&type=style&index=0&id=6bcd5e07&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports